import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import QuoteItemPrice from "../common/quote/itemprice.component.jsx"
import { STOCK_DOCUMENT_STATUS } from "../common/types/inventory"
import { ORDERS } from "../state/order/Constants"
import { setPricingTableItem } from '../state/pricing/actions'
import { getPricingTableId, getPricingTableItem, getPricingTableItemFees, getPricingTableItemTax, getPricingTableSelectedItems } from '../state/pricing/selectors'
import { INVENTORY_STOCK_DIRECTION, STOCK_DOCUMENTS } from '../utils/inventory'
import ImagePanelComponent from './components/ImagePanelComponent.tsx'
import PricePanelComponent from './components/PricePanelComponent.tsx'
import ProductInformation from './components/ProductInformationComponent.tsx'
import ProductStatusComponent from './components/ProductStatusComponent.tsx'
import SettingPanelComponent from './components/SettingPanelComponent.tsx'
import './styles/main.scss'


class PricingTableItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            item: this.props.item,
            className: this.props.className || '',
            productDescription: this.props.productDescription || 'long',
            type: this.props.type || 'quote',
            dragHandle: this.props.dragHandle || [],
            fees: this.props.fees || [],
            allowEdit: this.props.allowEdit || false,
            sortable: this.props.sortable === true,
            showOnlyProductInfo: this.props.showOnlyProductInfo || false,
            measure: '',
            unitPrice: '',
            additionalMeasure: '',
            itemTax: this.props.itemTax || null,
            location: this.props.location || null,
            users: this.props.users || [],
            setAssignedUserModal: <></>,
            showInventoryDetails: this.props.showInventoryDetails || false,
            mainObjectId: this.props.mainObjectId || '',
            invoicedMeasure: this.props.item?.attributes.invoicedMeasure || 0,
            itemSelection: this.props.itemSelection || new Set(),
            stockDocument: this.props.stockDocument || null,
            documentStatus: this.props.documentStatus || "",
        }
        this.onUpdateCallback = this.props.onUpdate || function () { }
        this.getTableItemTax = this.getTableItemTax.bind( this )
        this.shouldEditQuantity = this.shouldEditQuantity.bind( this )
        this.shouldEditPriceForStockDocument=this.shouldEditPriceForStockDocument.bind(this)
        this.hasAttributeInDescription = this.hasAttributeInDescription.bind(this)
    }

    componentDidMount() {
        this.setState({
            item: this.props.item,
            users: this.props.users || [],
            measure: this.props.item ? this.props.item.attributes.measure : '',
            unitPrice: this.props.item ? this.props.item.attributes.unitPrice : '',
            additionalMeasure: this.props.item ? this.props.item.attributes.additionalMeasure : '',
        }, this.refreshTooltip)
    }

    componentWillReceiveProps(nextProps) {
        const state = {
            item: nextProps.item,
            stockDocument:nextProps.stockDocument,
            measure:nextProps.item ? nextProps.item.attributes.measure : '',
            className: nextProps.className || '',
            itemSelection: nextProps.itemSelection || new Set(),
            productDescription: nextProps.productDescription || 'long',
            type: nextProps.type || 'quote',
            allowEdit: nextProps.allowEdit || false,
            fees: nextProps.fees || [],
            showOnlyProductInfo: nextProps.showOnlyProductInfo || false,
            showBillingMethod: nextProps.showBillingMethod === true,
            sortable: nextProps.sortable === true,
            location: nextProps.location || null,
            users: nextProps.users || [],
            itemTax: nextProps.itemTax || null,
            assignedToUserId: nextProps.item ? nextProps.item.attributes.assignedToUserId : '',
            mainObjectId: nextProps.mainObjectId || '',
            documentStatus: nextProps.documentStatus || "",
        }
        this.setState(state, this.refreshTooltip)
    }

    refreshTooltip() {
        $('[data-toggle="tooltip"]').tooltip()
    }

    hasAttributeInDescription() {
        return !this.props.item?.attributes.taxable
            || this.props.item?.attributes.hidePrice
            || (this.state.stockDocument && this.state.stockDocument.status?.attributes.state !== STOCK_DOCUMENT_STATUS.DRAFT)
            || (this.state.stockDocument && this.state.stockDocument.definition?.attributes.direction !== INVENTORY_STOCK_DIRECTION.IN_OUT)
            || (this.props.item?.attributes.type && this.props.item?.attributes.type !== "active")
            || !this.props.item?.attributes.feeApplicable
            || this.props.item?.attributes.measureEditable
            || this.props.item?.attributes.isDisabled
            || this.props.rowCustomStatuses.length > 0
            || parseFloat(this.state.item?.attributes.invoicedMeasure) > 0
            || AppContext.hasFeatureIntegration(Features.PurchaseOrderTracking)
            || this.props.item?.attributes.references?.find(ref => ref.attributes.referenceKey === STOCK_DOCUMENTS
            || ref.attributes.referenceKey === ORDERS)
            || AppContext.isInventoryEnabled()
    }

    getTableItemTax() {
        if (!this.state.item) {
            return null
        }
        if (!this.state.item.attributes.taxable) {
            return null
        }

        return this.state.itemTax
    }

    isRowSelected(rowId) {
        if (!rowId) {
            return false
        }
        return this.state.itemSelection && this.state.itemSelection.has(rowId)
    }

    shouldEditQuantity () {
        if ( !this.state.stockDocument ) {
            return this.state.allowEdit
        }

        if ( this.state.stockDocument && this.state.stockDocument.status.attributes.state !== STOCK_DOCUMENT_STATUS.DRAFT ) {
            return false
        }
        
        return true
    }

    shouldEditPriceForStockDocument () {
        if ( !this.state.stockDocument ) {
            return this.state.allowEdit
        }

        if ( this.state.stockDocument && this.state.stockDocument.status.attributes.state !== STOCK_DOCUMENT_STATUS.DRAFT ) {
            return false
        }
        
        if ( this.state.stockDocument && this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.OUT ) {
            return false
        }
    
        if ( this.state.stockDocument && this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN_OUT ) {
            if ( Number( this.state.measure ) < 0 ) {
                return false
            }
        }
        return true
    }

    render() {
        if (this.state.showOnlyProductInfo) {
            return <div className={this.state.className}>
                {this.state.item && <ProductInformation
                    productDescription={this.state.productDescription}
                    type={this.state.type}
                    allowEdit={this.state.allowEdit}
                    itemId={this.props.itemId}
                    mainObjectId={this.state.mainObjectId}
                    item={this.state.item}
                    fees={this.state.fees}
                    location={this.state.location}
                    advice={this.props.advice}
                />}
            </div>
        }

        return (
            <div id="pricingTableItem" className={"d-flex flex-wrap pl-1 py-2 "
                + (this.isRowSelected(this.state.item?.id) && "line-selected ")
                + (this.state.item?.attributes.isDisabled ? ' bg-light ' : '')
                + this.state.className}
                data-id={this.state.item?.id}
            >
                <div id={this.state.allowEdit ? "startPanel" : "startPanelModal"}>
                    <div className={"quote-item-content pb-2 pl-0 pr-0 d-flex flex-wrap " + (this.state.allowEdit ? '' : 'text-center')}>
                        <ImagePanelComponent
                            itemId={this.props.itemId}
                            mainObjectId={this.state.mainObjectId}
                            type={this.state.type}
                            sortable={this.state.sortable}
                            allowEdit={this.props.allowEdit}
                            dragHandle={this.state.dragHandle}
                            isRowSelected={(id) => this.isRowSelected(id)}
                        />
                    </div>

                    <div id={this.state.allowEdit ? "productInformation" : "productInformationModal"} className={"quote-item-content px-2 pb-2 d-flex"}>
                        <div className="w-100">
                            <div className={"w-100 d-flex " + (this.state.showInventoryDetails ? 'strong' : '')}>
                                {this.state.item && <ProductInformation
                                    productDescription={this.state.productDescription}
                                    type={this.state.type}
                                    allowEdit={this.props.allowEdit}
                                    location={this.state.location}
                                    itemId={this.props.itemId}
                                    mainObjectId={this.state.mainObjectId}
                                    fees={this.state.fees}
                                    advice={this.props.advice}
                                />}
                            </div>
                        </div>
                    </div>
                </div>

                {this.hasAttributeInDescription() && <div id={this.state.allowEdit ? "middlePanel" : ""} className="d-inline-flex flex-wrap">
                    <div id={this.state.allowEdit ? "productStatus" : "productStatusModal"} className="pb-2 mt-1 d-flex flex-wrap align-items-start">
                        <ProductStatusComponent
                            itemId={this.props.itemId}
                            mainObjectId={this.state.mainObjectId}
                            showInventoryDetails={this.state.showInventoryDetails}
                            location={this.state.location}
                            type={this.state.type}
                            allowEdit={this.props.allowEdit}
                            rowCustomStatuses={this.props.rowCustomStatuses}
                            fee={ this.state.fees }
                            stockDocument={this.state.stockDocument}
                            rowId={this.state.item?.id}
                            documentStatus={this.state.documentStatus}
                        />
                    </div>
                </div>}

                <div id={this.state.allowEdit ? "finalPanel" : "finalPanelModal"}>
                    {this.state.item &&
                        <div id={this.state.allowEdit ? "pricePanel" : "pricePanelModal"} className={"quote-item-content d-flex pb-2 align-items-start"}>
                            <SettingPanelComponent
                                itemId={this.props.itemId}
                                mainObjectId={this.state.mainObjectId}
                                showInventoryDetails={this.state.showInventoryDetails}
                                location={this.state.location}
                                type={this.state.type}
                                allowEdit={this.props.allowEdit}
                                fees={this.state.fees}
                                advice={this.state.advice}
                                fromShowDetails={this.props.fromShowDetails}
                                users={this.state.users}
                                getTableItemTax={ this.getTableItemTax }
                                shouldEditQuantity={ this.shouldEditQuantity() }
                                onEditLinkClick={this.props.onEditLinkClick || function () { }}
                                onUpdateCallback={() => this.onUpdateCallback()}
                                onChange={this.props.onChange}
                                stockDocument={this.state.stockDocument}
                            />                      
                            <PricePanelComponent
                                shortFormat={true}
                                itemId={this.props.itemId}
                                pricingTableId={this.props.pricingTableId}
                                mainObjectId={this.state.mainObjectId}
                                type={this.state.type}
                                allowEdit={ this.props.allowEdit }
                                shouldEditQuantity={ this.shouldEditQuantity() }
                                shouldEditPrice={this.shouldEditPriceForStockDocument()}
                                onUpdateCallback={() => this.onUpdateCallback()}
                                onChange={this.props.onChange}
                                syncItemsWithCatalogPrices={this.props.syncItemsWithCatalogPrices || false}
                                stockDocument={this.state.stockDocument}
                            /> 
                        </div>}
                    <div id={this.props.allowEdit ? "itemPrice" : "itemPriceModal"} className="pb-2 text-align-right d-flex mt-1 flex-column align-items-end justify-content-start">
                        {this.state.item && <div>
                            <QuoteItemPrice
                                itemId={this.state.item.id}
                                addedInputClass={"form-control-sm pl-2 ml-2"}
                                value={this.state.item}
                                type={ this.state.type }
                                editable={this.shouldEditPriceForStockDocument()}
                                mainObjectId={ this.state.mainObjectId }
                                stockDocument={this.state.stockDocument}
                            />
                        </div>}
                        {this.state.item && this.getTableItemTax() &&
                            this.getTableItemTax().id !== this.state.item.attributes.taxId &&
                            <div>
                                <small>
                                    <FormattedMessage
                                        id="quote.edit.numbers.tax"
                                        defaultMessage="Tax"
                                    />: {this.state.item.attributes.totalTaxRate}%
                                </small>
                            </div>
                        }
                    </div>
                </div>
                {this.state.setAssignedUserModal}
            </div>
        );
    }
}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
        itemSelection: getPricingTableSelectedItems(state, objectId),
        itemTax: getPricingTableItemTax(state, item, objectId),
        fees: getPricingTableItemFees(state, objectId),
        pricingTableId: getPricingTableId(state, objectId),
    }
}
const mapDispatch = (dispatch) => {
    return {
        setPricingTableItem: setPricingTableItem, 
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(PricingTableItem))


// WEBPACK FOOTER //
// ./src/pricing/PricingTableItemComponent.jsx